import React from "react";



import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';





function ProjectPage() {
  return (
    <div>

      {/* HERO SECTION */}

      <section className="hero-section">

        <div className="hero-image">
          {/* <img
            src="/innerpages/assets/img/projects/proj1.jpg"
            alt=""
          /> */}
            <img
            src="/home1/assets/img/projects/ashik-hero.webp"
            alt=""
          />
        </div>

        <div className="hero-bottom">

          <div className="hero-left">

            {/* <div className="logo-box">
              A
            </div>

            <div className="brand-text">
              ARKA CREATIVES
              <small>ARCHITECTURE STUDIO</small>
            </div> */}

          </div>

          <div className="hero-title">
            <h1>The Lady Willingdon High School</h1>
          </div>

          <button className="view-btn">
            View Gallery
          </button>

        </div>

      </section>

      {/* TOP NAV */}

      <section className="top-nav">

        <div className="nav-left">

          <div className="nav-project-title">
            <h2>The Lady Willingdon High School</h2>
            <span>ARKA CREATIVES</span>
          </div>

          <div className="nav-links">
            <a href="#">
              Architecture & Interior Photography
            </a>

            <a href="#">
              Updates
            </a>
          </div>

        </div>

        <div className="nav-right">
          <span>♡</span>
          <span>↓</span>
          <span>↗</span>
          <span>▶</span>
        </div>

      </section>

      {/* GALLERY */}

      <section className="gallery-section">

  <PhotoProvider>

    <div className="portfolio-grid">

      <div className="portfolio-item">

        <PhotoView src="/home1/assets/img/projects/h2.jpg">
          <img src="/home1/assets/img/projects/h2.jpg" alt="" />
        </PhotoView>

      </div>

      <div className="portfolio-item">

        <PhotoView src="/home1/assets/img/projects/h1.jpg">
          <img src="/home1/assets/img/projects/h1.jpg" alt="" />
        </PhotoView>

      </div>

      <div className="portfolio-item">

        <PhotoView src="/home1/assets/img/projects/h4.jpg">
          <img src="/home1/assets/img/projects/h4.jpg" alt="" />
        </PhotoView>

      </div>

      <div className="portfolio-item">

        <PhotoView src="/home1/assets/img/projects/h5.jpg">
          <img src="/home1/assets/img/projects/h5.jpg" alt="" />
        </PhotoView>

      </div>

      <div className="portfolio-item">

        <PhotoView src="/home1/assets/img/projects/h6.jpg">
          <img src="/home1/assets/img/projects/h6.jpg" alt="" />
        </PhotoView>

      </div>

      <div className="portfolio-item">

        <PhotoView src="/home1/assets/img/projects/h7.jpg">
          <img src="/home1/assets/img/projects/h7.jpg" alt="" />
        </PhotoView>

      </div>

      <div className="portfolio-item">

        <PhotoView src="/home1/assets/img/projects/h8.jpg">
          <img src="/home1/assets/img/projects/h8.jpg" alt="" />
        </PhotoView>

      </div>

      <div className="portfolio-item">

        <PhotoView src="/home1/assets/img/projects/h9.jpg">
          <img src="/home1/assets/img/projects/h9.jpg" alt="" />
        </PhotoView>

      </div>

      <div className="portfolio-item">

        <PhotoView src="/home1/assets/img/projects/h10.jpg">
          <img src="/home1/assets/img/projects/h10.jpg" alt="" />
        </PhotoView>

      </div>

      <div className="portfolio-item">

        <PhotoView src="/home1/assets/img/projects/h11.jpg">
          <img src="/home1/assets/img/projects/h11.jpg" alt="" />
        </PhotoView>

      </div>


    </div>

  </PhotoProvider>

</section>
      {/* INLINE CSS */}

      <style>
        
        {`

        *{
          margin:0;
          padding:0;
          box-sizing:border-box;
        }

        body{
          font-family:Arial, Helvetica, sans-serif;
          background:#fff;
          color:#111;
        }

        img{
          width:100%;
          display:block;
        }

        a{
          text-decoration:none;
          color:inherit;
        }

        /* HERO */

        .hero-section{
          width:100%;
          background:#f7f7f7;
          padding:20px;
        }

        .hero-image{
          width:100%;
          height:92vh;
          overflow:hidden;
        }

        .hero-image img{
          width:100%;
          height:100%;
          object-fit:cover;
        }

        .hero-bottom{
          display:flex;
          justify-content:space-between;
          align-items:center;
          padding:28px 30px;
          background:#f7f7f7;
        }

        .hero-left{
          display:flex;
          align-items:center;
          gap:14px;
        }

        .logo-box{
          width:50px;
          height:50px;
          background:#fff;
          display:flex;
          align-items:center;
          justify-content:center;
          font-weight:bold;
          font-size:18px;
        }

        .brand-text small{
          display:block;
          color:#777;
          font-size:11px;
          margin-top:4px;
          letter-spacing:1px;
        }

        .hero-title{
          text-align:center;
          flex:1;
        }

        .hero-title h1{
          font-size:56px;
          font-weight:400;
        }

        .view-btn{
          background:#222;
          color:#fff;
          border:none;
          padding:14px 28px;
          cursor:pointer;
        }

        /* TOP NAV */

        .top-nav{
          display:flex;
          justify-content:space-between;
          align-items:center;
          padding:22px 30px;
          border-bottom:1px solid #eee;
        }

        .nav-left{
          display:flex;
          align-items:center;
          gap:40px;
        }

        .nav-project-title h2{
          font-size:32px;
          font-weight:500;
        }

        .nav-project-title span{
          font-size:12px;
          color:#888;
        }

        .nav-links{
          display:flex;
          gap:30px;
          color:#666;
        }

        .nav-right{
          display:flex;
          gap:20px;
          font-size:20px;
        }






     /* =========================
   ARCHITECTURE GALLERY
========================= */

.gallery-section{

  width:100%;
  padding:12px;

}

/* GRID */

.portfolio-grid{

  display:grid;

  grid-template-columns:repeat(5,1fr);

  gap:12px;

}

/* CARD */

.portfolio-item{

  position:relative;

  overflow:hidden;

  height:340px;

  background:#f5f5f5;

  cursor:pointer;

}

/* IMAGE */

.portfolio-item img{

  width:100%;

  height:100%;

  object-fit:cover;

  display:block;

  transition:0.5s ease;

}

/* HOVER */

.portfolio-item:hover img{

  transform:scale(1.03);

}

/* LARGE LAPTOP */

@media(max-width:1400px){

  .portfolio-grid{

    grid-template-columns:repeat(4,1fr);

  }

}

/* TABLET */

@media(max-width:992px){

  .portfolio-grid{

    grid-template-columns:repeat(3,1fr);

  }

}

/* MOBILE */

@media(max-width:768px){

  .portfolio-grid{

    grid-template-columns:repeat(2,1fr);

  }

  .portfolio-item{

    height:280px;

  }

}

/* SMALL MOBILE */

@media(max-width:500px){

  .portfolio-grid{

    grid-template-columns:1fr;

  }

}





        /* MOBILE */

        @media(max-width:768px){

          .hero-image{
            height:60vh;
          }

          .hero-bottom{
            flex-direction:column;
            gap:25px;
            text-align:center;
          }

          .hero-title h1{
            font-size:34px;
          }

          .top-nav{
            flex-direction:column;
            align-items:flex-start;
            gap:20px;
          }

          .nav-left{
            flex-direction:column;
            align-items:flex-start;
            gap:20px;
          }

          .large{
            grid-column:span 1;
          }

        }

        `}
      </style>

    </div>
  );
}

export default ProjectPage;













